(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_short-description-product"] && !Shopify.designMode) return;
  try {
    class ShortDescription extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('[data-sd-text]');
    this.toggle = this.querySelector('[data-sd-toggle]');
    if (!this.text) return;

    // Clamp first, then reveal the toggle only when content actually overflows.
    this.text.classList.add('is-clamped');
    requestAnimationFrame(() => this.evaluate());
    window.addEventListener('resize', () => this.onResize());
  }

  evaluate() {
    if (!this.toggle) return;
    const overflowing = this.text.scrollHeight > this.text.clientHeight + 1;
    if (overflowing) {
      this.toggle.hidden = false;
    } else {
      this.toggle.hidden = true;
      this.text.classList.remove('is-clamped');
    }
    if (!this.bound) {
      this.toggle.addEventListener('click', () => this.onToggle());
      this.bound = true;
    }
  }

  onResize() {
    // Re-evaluate overflow only while collapsed.
    if (this.toggle && this.toggle.getAttribute('aria-expanded') !== 'true') {
      this.text.classList.add('is-clamped');
      this.evaluate();
    }
  }

  onToggle() {
    const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
    this.toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    this.text.classList.toggle('is-clamped', expanded);
    const more = this.toggle.querySelector('[data-sd-more]');
    const less = this.toggle.querySelector('[data-sd-less]');
    if (more && less) {
      more.hidden = !expanded;
      less.hidden = expanded;
    }
  }
}

if (!customElements.get('short-description')) {
  customElements.define('short-description', ShortDescription);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_wishlist-button-product"] && !Shopify.designMode) return;
  try {
    class WishlistButton extends HTMLElement {
  static STORAGE_KEY = 'namane:wishlist';

  connectedCallback() {
    this.handle = this.dataset.wishlistHandle;
    this.button = this.querySelector('button');
    if (!this.handle || !this.button) return;
    this.syncState();
    this.button.addEventListener('click', () => this.toggle());
    window.addEventListener('storage', (e) => {
      if (e.key === WishlistButton.STORAGE_KEY) this.syncState();
    });
  }

  getList() {
    try {
      return JSON.parse(localStorage.getItem(WishlistButton.STORAGE_KEY)) || [];
    } catch { return []; }
  }

  saveList(list) {
    localStorage.setItem(WishlistButton.STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list } }));
  }

  syncState() {
    const list = this.getList();
    const isInWishlist = list.includes(this.handle);
    this.button.setAttribute('aria-pressed', isInWishlist ? 'true' : 'false');
    this.button.setAttribute('aria-label', isInWishlist ? 'Remove from wishlist' : 'Add to wishlist');
  }

  toggle() {
    let list = this.getList();
    if (list.includes(this.handle)) {
      list = list.filter((h) => h !== this.handle);
    } else {
      list.push(this.handle);
    }
    this.saveList(list);
    this.syncState();
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}
  } catch(e) { console.error(e); }
})();

})();
